(function () {
  'use strict';

  var CFG = Object.assign({
    endpoint: '',
    partner: 'pidbir',
    phone: '',
    phoneLabel: '',
    thanksUrl: '/',
    storePrefix: 'clm_pidbir',
    nativeSubmit: false,
    demoMode: false,
    appStoreUrl: '',
    googlePlayUrl: '',
    recaptchaSiteKey: '',
    recaptchaVerifyUrl: '',
    recaptchaNonce: ''
  }, window.LEAD_CONFIG || {});

  var DEMO_HOST = location.protocol === 'file:' ||
    /^(localhost|127\.0\.0\.1|\[::1\])$|\.sslip\.io$|\.local$/.test(location.hostname);
  var DEMO = CFG.demoMode === true && DEMO_HOST;

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
                  'gclid', 'gbraid', 'wbraid', 'fbclid'];
  var STORE_KEY = CFG.storePrefix + '_utm';

  function readUtm() {
    var q = new URLSearchParams(location.search);
    var fromUrl = {}, has = false;
    UTM_KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v !== null && v !== '') { fromUrl[k] = v; has = true; }
    });
    if (has) {
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(fromUrl)); } catch (e) {}
      return fromUrl;
    }
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}'); } catch (e) { return {}; }
  }
  var utm = readUtm();

  (function pickCampaignPhone() {
    var map = CFG.phoneMap || {};
    var campaign = utm.utm_campaign || '';
    var entry = campaign && Object.prototype.hasOwnProperty.call(map, campaign) ? map[campaign] : null;
    if (entry && entry.phone) {
      CFG.phone = entry.phone;
      CFG.phoneLabel = entry.label || '';
    } else if (CFG.defaultPhone) {
      CFG.phone = CFG.defaultPhone;
      CFG.phoneLabel = CFG.defaultPhoneLabel || '';
    }
  })();

  var PHONE_DIGITS = String(CFG.phone || '').replace(/[^\d+]/g, '');
  var PHONE_PRETTY = '';
  (function applyPhone() {
    var digits = PHONE_DIGITS;
    if (!digits) {
      document.querySelectorAll('.js-phone-link').forEach(function (a) { a.hidden = true; a.removeAttribute('href'); });
      document.querySelectorAll('[data-needs-phone]').forEach(function (el) { el.hidden = true; });
      document.body.classList.add('no-phone');
      return;
    }
    var pretty = CFG.phoneLabel || digits;
    if (!CFG.phoneLabel) {
      var m = digits.match(/^\+380(\d{2})(\d{3})(\d{2})(\d{2})$/);
      if (m) pretty = '+380 ' + m[1] + ' ' + m[2] + ' ' + m[3] + ' ' + m[4];
    }
    PHONE_PRETTY = pretty;
    document.querySelectorAll('.js-phone-link').forEach(function (a) {
      a.href = 'tel:' + digits; a.hidden = false;
      if (a.classList.contains('header-phone') || a.classList.contains('mobile-cta__call')) a.setAttribute('aria-label', 'Зателефонувати ' + pretty);
    });
    document.querySelectorAll('.js-phone-text').forEach(function (el) { el.textContent = pretty; });
    document.querySelectorAll('[data-needs-phone]').forEach(function (el) { el.hidden = false; });

    document.querySelectorAll('.js-phone-link').forEach(function (a) {
      a.addEventListener('click', function () {
        if (window.dataLayer) window.dataLayer.push({ event: 'phone_click' });
      });
    });
  })();

  if (CFG.appStoreUrl) document.querySelectorAll('.js-appstore').forEach(function (a) { a.href = CFG.appStoreUrl; });
  if (CFG.googlePlayUrl) document.querySelectorAll('.js-gplay').forEach(function (a) { a.href = CFG.googlePlayUrl; });

  var forms = [].slice.call(document.querySelectorAll('.js-lead-form'));

  function setHidden(form, name, value) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el) el.value = value == null ? '' : value;
  }

  forms.forEach(function (form) {
    UTM_KEYS.forEach(function (k) { setHidden(form, k, utm[k] || ''); });
    setHidden(form, 'referer', document.referrer || location.href);
    setHidden(form, 'partner', CFG.partner);
  });

  function groupsOf(input) {
    var g = (input.getAttribute('data-groups') || '').trim();
    return g ? g.split(',').map(Number) : [];
  }
  function maxDigits(input) { return parseInt(input.getAttribute('data-max'), 10) || 15; }
  function formatDigits(digits, groups) {
    if (!groups.length) return digits;
    var out = [], i = 0;
    for (var k = 0; k < groups.length && i < digits.length; k++) {
      out.push(digits.slice(i, i + groups[k]));
      i += groups[k];
    }
    if (i < digits.length) out.push(digits.slice(i));
    return out.filter(Boolean).join(' ');
  }
  function placeholderFor(groups) {
    if (!groups.length) return '________';
    return groups.map(function (n) { return new Array(n + 1).join('_'); }).join(' ') + ' *';
  }
  function normalizeDigits(digits, form, max) {
    var ccEl = form && form.querySelector('.js-lf-cc-code');
    var cc = ccEl ? ccEl.textContent.trim() : '';
    var ccDigits = cc.replace(/\D/g, '');
    if (ccDigits && digits.length > max && digits.indexOf(ccDigits) === 0) digits = digits.slice(ccDigits.length);
    if (cc !== '+') digits = digits.replace(/^0+/, '');
    return digits.slice(0, max);
  }

  document.querySelectorAll('.js-lf-phone').forEach(function (input) {
    input.addEventListener('input', function () {
      var digits = (input.value.match(/\d/g) || []).join('');
      digits = normalizeDigits(digits, input.form, maxDigits(input));
      input.value = formatDigits(digits, groupsOf(input));
      input.classList.remove('is-bad');
      clearErr(input.form, 'phone');
    });
    input.addEventListener('keypress', function (e) {
      if (e.key && e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    });
  });

  document.querySelectorAll('.js-lf-cc').forEach(function (cc) {
    var btn = cc.querySelector('.js-lf-cc-btn');
    var list = cc.querySelector('.js-lf-cc-list');
    var flag = cc.querySelector('.js-lf-cc-flag');
    var code = cc.querySelector('.js-lf-cc-code');
    var input = cc.closest('.lf-phone').querySelector('.js-lf-phone');
    var form = cc.closest('form');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      closeAllCc();
      list.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) placeList(cc, list);
    });
    cc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) { e.stopPropagation(); list.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });

    list.querySelectorAll('.lf-cc-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        code.textContent = opt.getAttribute('data-code');
        flag.src = opt.getAttribute('data-flag');
        input.setAttribute('data-max', opt.getAttribute('data-max'));
        input.setAttribute('data-groups', opt.getAttribute('data-groups'));
        setHidden(form, 'country_code', opt.getAttribute('data-country') || '');
        var digits = normalizeDigits((input.value.match(/\d/g) || []).join(''), form, maxDigits(input));
        input.value = formatDigits(digits, groupsOf(input));
        input.placeholder = placeholderFor(groupsOf(input));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
    });
  });
  function placeList(cc, list) {
    list.classList.remove('is-up');
    var box = cc.closest('.qp__win');
    var limitTop = box ? box.getBoundingClientRect().top : 0;
    var limitBottom = box ? box.getBoundingClientRect().bottom : window.innerHeight;
    var btnRect = cc.getBoundingClientRect();
    var h = list.offsetHeight;
    var below = limitBottom - btnRect.bottom;
    var above = btnRect.top - limitTop;
    if (h > below - 8 && above > below) list.classList.add('is-up');
  }
  function closeAllCc() {
    document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
    document.querySelectorAll('.js-lf-cc-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', closeAllCc);

  function setErr(form, field, msg) {
    if (!form) return;
    var input = form.querySelector('[name="' + field + '"]');
    var err = form.querySelector('.lf-err[data-for="' + field + '"]');
    if (input) {
      input.classList.toggle('is-bad', !!msg);
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
      if (err) {
        if (!err.id) err.id = 'lfErr-' + field + '-' + Math.random().toString(36).slice(2, 6);
        input.setAttribute('aria-describedby', err.id);
      }
    }
    if (err) { err.textContent = msg || ''; err.classList.toggle('is-on', !!msg); }
  }
  function clearErr(form, field) { setErr(form, field, ''); }

  function getRecaptchaToken() {
    if (!CFG.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
      return Promise.resolve('');
    }
    return new Promise(function (resolve) {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(CFG.recaptchaSiteKey, { action: 'lead_submit' })
          .then(resolve)
          .catch(function () { resolve(''); });
      });
    });
  }

  function verifyRecaptcha(token) {
    if (!CFG.recaptchaSiteKey) return Promise.resolve(true);
    var body = new URLSearchParams({
      action: 'pidbir_verify_recaptcha',
      nonce: CFG.recaptchaNonce || '',
      token: token
    });
    return fetch(CFG.recaptchaVerifyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (result) { return !!(result && result.success); })
      .catch(function () { return false; });
  }

  function logLead(lead) {
    try {
      var arr = JSON.parse(localStorage.getItem(CFG.storePrefix + '_leads') || '[]');
      arr.push(lead);
      localStorage.setItem(CFG.storePrefix + '_leads', JSON.stringify(arr.slice(-50)));
    } catch (e) {}
  }

  function sendLead(lead) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    return fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lead),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      if (!r.ok) throw new Error('bad status ' + r.status);
      return true;
    });
  }

  function trackLead(lead) {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'generate_lead', lead_source: lead.source, lead_direction: lead.direction });
    }
  }

  function offlineMessage() {
    return 'Не вдалося надіслати заявку.' + (PHONE_PRETTY ? ' Зателефонуйте: ' + PHONE_PRETTY : ' Спробуйте ще раз за хвилину.');
  }

  function setBusy(form, on) {
    form.dataset.busy = on ? '1' : '';
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    if (on) { btn.dataset.label = btn.textContent; btn.textContent = 'Надсилаємо…'; btn.disabled = true; }
    else { if (btn.dataset.label) btn.textContent = btn.dataset.label; btn.disabled = false; }
  }

  function collectQualifiers(form) {
    var list = [];
    form.querySelectorAll('[name^="q_"]').forEach(function (el) {
      if (!el.value) return;
      list.push({
        field: el.name.slice(2),
        question: el.getAttribute('data-question') || el.name.slice(2),
        answer: el.value
      });
    });
    return list.length ? list : null;
  }

  forms.forEach(function (form) {
    form.querySelectorAll('.lf-input').forEach(function (inp) {
      inp.addEventListener('input', function () { clearErr(form, inp.name); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.busy === '1') return;

      var nameEl = form.querySelector('[name="customer_name"]');
      var phone = form.querySelector('[name="phone"]');
      var qEl = form.querySelector('.js-question');
      var ccEl = form.querySelector('.js-lf-cc-code');
      var cc = ccEl ? ccEl.textContent.trim() : '+380';
      var digits = (phone.value.match(/\d/g) || []).join('');
      var need = maxDigits(phone);
      var ok = true;

      if (!digits.length) {
        setErr(form, 'phone', 'Вкажіть номер телефону'); ok = false;
      } else if (cc === '+' ? digits.length < 7 : digits.length !== need) {
        setErr(form, 'phone', 'Номер має містити ' + (cc === '+' ? 'щонайменше 7' : need) + ' цифр'); ok = false;
      } else clearErr(form, 'phone');

      if (!ok) {
        var bad = form.querySelector('.lf-input.is-bad');
        if (bad) bad.focus();
        return;
      }

      var dirEl = form.querySelector('.js-direction');
      var dirSel = dirEl ? ((dirEl.options[dirEl.selectedIndex] || {}).value || '') : '';
      var defDir = form.getAttribute('data-default-direction') || '';
      var qText = qEl ? qEl.value.trim() : '';
      var direction = dirSel || defDir || qText;
      var directionSource = dirSel ? 'select' : defDir ? 'default' : (qText ? 'question' : 'none');

      setHidden(form, 'direction', direction);
      setHidden(form, 'direction_source', directionSource);

      if (CFG.nativeSubmit && form.getAttribute('action')) {
        setBusy(form, true);
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'generate_lead', lead_source: form.getAttribute('data-source') || form.id, lead_direction: direction });
        }
        form.submit();
        return;
      }

      if (!CFG.endpoint && !DEMO) {
        setErr(form, 'phone', offlineMessage());
        return;
      }

      var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      try { sessionStorage.setItem(CFG.storePrefix + '_lead_ref', leadRef); } catch (err) {}

      var lead = {
        lead_ref: leadRef,
        source: form.getAttribute('data-source') || form.id,
        partner: CFG.partner,
        customer_name: nameEl ? nameEl.value.trim() : '',
        phone: cc + ' ' + phone.value.trim(),
        country_code: (form.querySelector('[name="country_code"]') || {}).value || '',
        direction: direction,
        direction_source: directionSource,
        practice_key: (form.querySelector('[name="practice_key"]') || {}).value || '',
        question: qText,
        qualifiers: collectQualifiers(form),
        utm: utm,
        referer: document.referrer || '',
        page: location.href,
        ts: new Date().toISOString()
      };

      setBusy(form, true);
      getRecaptchaToken().then(function (recaptchaToken) {
        return verifyRecaptcha(recaptchaToken).then(function (recaptchaOk) {
          if (!recaptchaOk) { throw new Error('recaptcha_failed'); }
          lead.recaptcha_token = recaptchaToken || '';
          logLead(lead);
          var go = function () {
            trackLead(lead);
            location.href = CFG.thanksUrl || '/';
          };
          if (!CFG.endpoint) { go(); return; }
          return sendLead(lead).then(go, function () {
            try { sessionStorage.removeItem(CFG.storePrefix + '_lead_ref'); } catch (err) {}
            setBusy(form, false);
            setErr(form, 'phone', offlineMessage());
          });
        });
      }).catch(function () {
        try { sessionStorage.removeItem(CFG.storePrefix + '_lead_ref'); } catch (err) {}
        setBusy(form, false);
        setErr(form, 'phone', 'Не вдалося підтвердити, що ви не робот. Спробуйте ще раз.');
      });
    });
  });

  function scrollToEl(target, after) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 74;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (after) setTimeout(after, 600);
  }

  document.querySelectorAll('a[href*="#"]').forEach(function (a) {
    if (a.classList.contains('js-quiz-open')) return;
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href') || '';
      var idx = href.indexOf('#');
      var base = href.slice(0, idx);
      var id = href.slice(idx);
      if (!id || id === '#') return;
      if (base && base.replace(/\/$/, '') !== (location.origin + location.pathname).replace(/\/$/, '') && base.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      scrollToEl(target, function () {
        var f = target.querySelector('.js-lead-form [name="customer_name"]');
        if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
      });
    });
  });

  var mcta = document.getElementById('mobileCta');
  var heroCtas = document.getElementById('heroCtas') || document.getElementById('heroLeadForm') || document.querySelector('.hero');
  var leadSection = document.getElementById('lead');
  if (mcta && heroCtas && 'IntersectionObserver' in window) {
    var heroVisible = true, leadVisible = false;
    var sync = function () { mcta.classList.toggle('is-on', !heroVisible && !leadVisible); };
    new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; sync(); },
      { threshold: 0.15 }).observe(heroCtas);
    if (leadSection) {
      new IntersectionObserver(function (en) { leadVisible = en[0].isIntersecting; sync(); },
        { threshold: 0.2 }).observe(leadSection);
    }
  }

  (function counters() {
    var els = [].slice.call(document.querySelectorAll('.js-count'));
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0'); }
    function run(el) {
      var to = parseInt(el.getAttribute('data-to'), 10) || 0;
      var suf = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = fmt(to) + suf; return; }
      var t0 = null, dur = 1400;
      function step(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var ease = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt(Math.round(to * ease)) + suf;
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting || e.target.dataset.done) return;
        e.target.dataset.done = '1';
        run(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { el.textContent = '0'; io.observe(el); });
  })();

  document.querySelectorAll('details.burger').forEach(function (d) {
    d.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { d.open = false; }); });
    document.addEventListener('click', function (e) { if (!d.contains(e.target)) d.open = false; });
  });

  var header = document.querySelector('header.site');
  function setHdr() {
    if (header) document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px');
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  window.addEventListener('load', setHdr);
})();